import React, { useState, useEffect } from "react";
import VehicleCard from "../../../vehicle-card/VehicleCard";
import BaseButtons from "../../../../../base-buttons/BaseButtons";
import { colors } from "../../../../../../../themes/Colors";
import TextInputField from "../../../../../text-input-field/TextInputField";
import TextInputFieldArea from "../../../../../text-input-field/TextInputFieldArea";
import AWS from "aws-sdk";

const VehicleCertificates = ({
  data,
  setMessage,
  setPopUpTitle,
  setToastPop,
  setLoading,
}) => {
  const [rc1Display, setRc1Display] = useState(false);
  const [rc1Form, setRc1Form] = useState(null);
  const [rc1FormImage, setRc1FormImage] = useState(null);

  // get rc1 form ceryifcate and allow for other forms to be added here
  //display all forms
  const getRc1Form = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/vehicleAction/getRc1Form",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            vehicleIdentifier: data ? data._id : null,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setRc1Form(respnseData.rc1Form);

        // setToastPop(true);
      }
    } catch (err) {}
  };

  const getUplaodImage = async () => {
    const S3_BUCKET = process.env.REACT_APP_BUCKET;
    const apiKey = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
    const secrectapiKey = process.env.REACT_APP_AWS_SECRET_KEY_ID;
    AWS.config.update({
      accessKeyId: apiKey,
      secretAccessKey: secrectapiKey,
    });
    const s3 = new AWS.S3({
      params: { Bucket: S3_BUCKET },
      region: process.env.REACT_APP_REGION,
      signatureVersion: "v4",
    });

    const params = {
      Bucket: S3_BUCKET,
      Key: rc1Form.loadedDocumentId,
    };

    var promise = s3.getSignedUrlPromise("getObject", params);
    // return promise;
    promise.then(
      function (url) {
        if (url) {
          setRc1FormImage(url);
        }
        return url;
      },
      function (err) {
        console.log(err);
      }
    );
  };

  useEffect(() => {
    if (data) {
      getRc1Form();
    }
  }, [data]);
  useEffect(() => {
    if (rc1Form) {
      getUplaodImage();
    }
  }, [rc1Form]);

  return (
    <div
      style={{
        width: "100%",
        // marginTop: 10,
        flex: 1,
        display: "flex",
        flexDirection: "column",
        overflowY: "scroll",
        overflowX: "hidden",
      }}
    >
      <div
        style={{
          width: "100%",
          // paddingTop: 20,
          // paddingBottom: 20,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 120,
          marginTop: 10,
        }}
      >
        <VehicleCard
          width={"100%"}
          // onManageClick={
          //   width > 899
          //     ? () => setManageVehicle(vehicle)
          //     : () => setVehicleManageView(vehicle)
          // }
          // type={type}
          licenceNr={data ? data.liscenseNumber : "loading"}
          // engineNr={vehicle.engineNumber}
          make={data ? data.make : "loading"}
          series={data ? data.series : "loading"}
          expireDate={"200 days"}
          // index={index + 1}
        />
      </div>
      <div
        style={{
          width: "100%",
          minHeight: 50,
          borderTopStyle: "solid",
          borderBottomStyle: "solid",
          marginTop: 20,
          borderColor: "#00000050",
          marginBottom: 10,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: "bold",
          fontSize: 16,
          color: "#00000080",
        }}
      >
        VEHICLE CERTIFICATES
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: 20,
        }}
      >
        <BaseButtons
          label={"RC1 CERTIFICATE OF REGISTRATION"}
          width={"90%"}
          borderRadius={8}
          backgroundColor={colors.greenLight}
          onClick={() => setRc1Display(rc1Display ? false : true)}
        />
      </div>
      {rc1Display ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            flexDirection: "column",
            marginBottom: 80,
          }}
        >
          <div
            style={{
              width: "90%",
              backgroundColor: colors.white,
              borderRadius: 8,
              paddingTop: 20,
              paddingBottom: 20,
              WebkitBoxShadow: "0px 0px 7px 2px #00000080",
              marginTop: 20,
            }}
          >
            <TextInputField
              labelTitle={"Vehicle registration nr"}
              mini={true}
              readOnly={true}
              value={rc1Form ? data.registerNumber : "loading"}
              width={"100%"}
              size={"80%"}
            />
            <TextInputField
              labelTitle={"Vehicle identification nr. (VIN nr.)"}
              mini={true}
              readOnly={true}
              value={rc1Form ? data.vinNumber : "loading"}
              width={"100%"}
              size={"80%"}
            />
            <TextInputField
              labelTitle={"Engine nr"}
              mini={true}
              readOnly={true}
              value={rc1Form ? data.engineNumber : "loading"}
              width={"100%"}
              size={"80%"}
            />
            <TextInputField
              labelTitle={"Liscense nr"}
              mini={true}
              readOnly={true}
              value={rc1Form ? data.liscenseNumber : "loading"}
              width={"100%"}
              size={"80%"}
            />
            <TextInputField
              labelTitle={"Make"}
              mini={true}
              readOnly={true}
              value={rc1Form ? data.make : "loading"}
              width={"100%"}
              size={"80%"}
            />
            <TextInputField
              labelTitle={"Series"}
              mini={true}
              readOnly={true}
              value={rc1Form ? data.series : "loading"}
              width={"100%"}
              size={"80%"}
            />
            <TextInputField
              labelTitle={"Vehicle Category"}
              mini={true}
              readOnly={true}
              value={rc1Form ? rc1Form.vehicleCategory : "loading"}
              width={"100%"}
              size={"80%"}
            />
            <TextInputField
              labelTitle={"Driven"}
              mini={true}
              readOnly={true}
              value={rc1Form ? rc1Form.vehicleDriven : "loading"}
              width={"100%"}
              size={"80%"}
            />
            <TextInputFieldArea
              labelTitle={"Vehicle description"}
              mini={true}
              readOnly={true}
              value={rc1Form ? rc1Form.vehicleDescription : "loading"}
              width={"100%"}
              size={"80%"}
              height={100}
            />

            <TextInputField
              labelTitle={"Tare kg"}
              mini={true}
              readOnly={true}
              value={rc1Form ? rc1Form.tareKg : "loading"}
              width={"100%"}
              size={"80%"}
            />
            <TextInputField
              labelTitle={"Date of liability for first licensing "}
              mini={true}
              readOnly={true}
              value={
                rc1Form ? rc1Form.dateOfLiabilityForFirstLiscensing : "loading"
              }
              width={"100%"}
              size={"80%"}
            />
            <TextInputField
              labelTitle={"Vehicle Status"}
              mini={true}
              readOnly={true}
              value={rc1Form ? rc1Form.vehicleStatus : "loading"}
              width={"100%"}
              size={"80%"}
            />
            <TextInputField
              labelTitle={"Last 3 licence nr."}
              mini={true}
              readOnly={true}
              value={rc1Form ? rc1Form.last3LiscenseNr : "loading"}
              width={"100%"}
              size={"80%"}
            />
            <div
              style={{
                width: "100%",
                textAlign: "center",
                marginTop: 20,
                marginBottom: "20",
                fontWeight: "bold",
              }}
            >
              TITLE HOLDER
            </div>
            <TextInputField
              labelTitle={"Type of identification"}
              mini={true}
              readOnly={true}
              value={"ID DOCUMENT"}
              width={"100%"}
              size={"80%"}
            />
            <TextInputField
              labelTitle={"ID number"}
              mini={true}
              readOnly={true}
              value={rc1Form ? rc1Form.identityNr : "loading"}
              width={"100%"}
              size={"80%"}
            />
            <TextInputField
              labelTitle={"Name"}
              mini={true}
              readOnly={true}
              value={rc1Form ? rc1Form.name : "loading"}
              width={"100%"}
              size={"80%"}
            />
            <TextInputField
              labelTitle={"Date of issue"}
              mini={true}
              readOnly={true}
              value={rc1Form ? rc1Form.dateOfIssue : "loading"}
              width={"100%"}
              size={"80%"}
            />
            <div
              style={{
                width: "100%",
                textAlign: "center",
                marginTop: 20,
                marginBottom: "20",
                fontWeight: "bold",
              }}
            >
              RECIEPT
            </div>
            <TextInputField
              labelTitle={"Transaction"}
              mini={true}
              readOnly={true}
              value={rc1Form ? rc1Form.transactionNr : "loading"}
              width={"100%"}
              size={"80%"}
            />
            <div
              style={{
                width: "100%",
                textAlign: "center",
                marginTop: 20,

                fontWeight: "bold",
              }}
            >
              UPLOADED DOCUMENT
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: 20,
              }}
            >
              <img
                alt="icon"
                src={rc1FormImage}
                style={{
                  width: "90%",

                  // borderRadius: 20,
                }}
              />
            </div>
          </div>
        </div>
      ) : null}
      <div
        style={{
          position: "fixed",
          bottom: 20,
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          width: "100%",
        }}
      >
        <BaseButtons
          label={"BUTTON"}
          borderRadius={8}
          backgroundColor={colors.orangeDark}
          width={"90%"}
        />
      </div>
    </div>
  );
};

export default VehicleCertificates;
